import { ListItem } from '../ListItem';

export class MessageStatus {

    static List(): ListItem[] {

        let list: ListItem[] = [
            { "id": -3, "name": "duplicated" },
            { "id": 0, "name": "unknown" },
            { "id": 1, "name": "sent" },
            { "id": 2, "name": "surveyresponded" },
            { "id": 3, "name": "scheduled" },
            { "id": 4, "name": "halted" },
            { "id": 5, "name": "softbounced" },
            { "id": 6, "name": "hardbounced" },
            { "id": 7, "name": "deliveredbyprovider" },
            { "id": 8, "name": "rejectedbyprovider" },
            { "id": 10, "name": "notsent" },
            { "id": 99, "name": "error" },

        ];

        return list;
    }

    static Name(id: number): string {

        let rtn: string = "";

        MessageStatus.List().forEach(obj => {

            if (obj.id == id) {
                rtn = obj.name;
            }

        });

        return rtn;

    }

    static Value(name: string): number {

        let rtn: number = 0;

        MessageStatus.List().forEach(obj => {

            if (obj.name == name) {
                rtn = obj.id;
            }

        });

        return rtn;

    }

}